import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import "./PrintConfiguration.scss";
import { useSelector } from "react-redux";
import Toast from "components/Toast";
import { updatePrintConfiguration } from 'core/services/api/masterService';
import { useHistory } from 'react-router';
import { getPrintConfiguration } from 'core/utils/print';


function PrintConfiguration() {

  const marginStylesInput = {
    marginTop: "100",
    marginBottom: "30",
    marginLeft: "30",
    marginRight: ""
  }

  const [marginStyles, setMarginStyles] = useState<any>(marginStylesInput);
  const [marginLeftError, setMarginLeftError] = useState("");
  const [marginRightError, setMarginRightError] = useState("");

  useEffect(() => {
    getPrintConfiguration()
      .then((res) => {
        setMarginStyles(res)
      })
      .catch((err) => {
        console.log(err, "Error");

      })
  }, [])

  const [displayToast, toggleDisplayToast] = useState<any>()
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);
  const history = useHistory()

  const saveMarginDetails = (() => {


    const payload = {
      marginTop: marginStyles.marginTop,
      marginLeft: marginStyles.marginLeft,
      marginRight: marginStyles.marginRight,
      marginBottom: marginStyles.marginBottom
    }
    console.log(marginLeftError.length, "margin left length");
    console.log(marginRightError.length, "margin Right length");
    if (marginLeftError.length < 1 && marginRightError.length < 1) {
      updatePrintConfiguration(payload)
        .then((res) => {
          toggleDisplayToast({ text: "Print Configuration saved successfully", type: "success" })
          setMarginLeftError("");
          setMarginRightError("");
        })
        .catch((err) => {
          console.log("err", err)
          toggleDisplayToast({ text: "Not able to Save Print Configurations", type: "error" })
        })
    }
    else {
      toggleDisplayToast({ text: "Please enter appropriate values", type: "error" });
    }
  })

  useEffect(() => {
    if (marginStyles.marginLeft >= 51) {
      setMarginLeftError("Max limit for margin-left is 50px");
    } else {
      setMarginLeftError("");
    }

    if (marginStyles.marginRight >= 21) {
      setMarginRightError("Max limit for margin-right is 20px");
    } else {
      setMarginRightError("");
    }

    console.log(marginStyles, "margin styles");
  }, [marginStyles]);


  return (
    <div className='print-configurtion-wrapper'>
      <div className='Heading' >
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>
        Print Configuration</div>
      <div className='main-container'>
        <div className='page-setup-container'>
          <div className='subheading-main'>Page Setup (A4)</div>
          <div className='subheading' style={{ color: 'blue' }}>Margins</div>
          <div className='margin-row'>
            <div className='subheading'>Margin-Top</div>
            <div className='pixel-units'>
              <input
                type="number"
                className="form-control-width"
                name="margin-top"
                readOnly={readOnly}
                value={marginStyles.marginTop}
                onChange={(e: any) => {
                  setMarginStyles({ ...marginStyles, marginTop: e.target.value })
                }}
              />
              <div className='unit'>px</div>
            </div>
          </div>

          <div className='margin-row'>
            <div className='subheading'>Margin-Left</div>
            <div className='pixel-units'>
              <input
                type="number"
                className="form-control-width"
                name="margin-left"
                readOnly={readOnly}
                value={marginStyles.marginLeft}
                onChange={(e: any) => {
                  setMarginStyles({ ...marginStyles, marginLeft: e.target.value })
                }}
              />
              <div className='unit'>px</div>
            </div>
          </div>
          <div className='error-message'>{marginLeftError}</div>
          <div className='margin-row'>
            <div className='subheading'>Margin-Right</div>
            <div className='pixel-units'>
              <input
                type="number"
                className="form-control-width"
                name="margin-right"
                readOnly={readOnly}
                value={marginStyles.marginRight}
                onChange={(e: any) => {
                  setMarginStyles({ ...marginStyles, marginRight: e.target.value })
                }}
              />
              <div className='unit'>px</div>
            </div>
          </div>
          <div className='error-message'>{marginRightError}</div>
          <div className='margin-row'>
            <div className='subheading'>Margin-Bottom</div>
            <div className='pixel-units'>
              <input
                type="number"
                className="form-control-width"
                name="margin-bottom"
                readOnly={readOnly}
                value={marginStyles.marginBottom}
                onChange={(e: any) => {
                  setMarginStyles({ ...marginStyles, marginBottom: e.target.value })
                }}
              />
              <div className='unit'>px</div>
            </div>
          </div>

          <Button className='common-button'
            disabled={readOnly}
            onClick={() => {
              //saveInvoiceDetails()
              saveMarginDetails()

            }}
          >{"Save"}</Button>

        </div>
        <div className='page-preview-container'>
          <div className='subheading' style={{ color: 'blue', paddingLeft: '10px' }}></div>
          <div
            className='preview-container'
            style={{
              marginTop: `${marginStyles.marginTop}px`,
              marginLeft: `${marginStyles.marginLeft}px`,
              marginRight: `${marginStyles.marginRight}px`,
              marginBottom: `${marginStyles.marginBottom}px`
            }}
          >
            <table id="tablePreview" className="table table-bordered table-hover">
              <thead style={{ backgroundColor: "rgb(225, 227, 239)" }}>
                <tr>
                  <th>SL.no</th>
                  <th>Patient ID</th>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Appointment Type</th>
                </tr></thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>M1235</td>
                  <td>Amar Shaw</td>
                  <td>9127689010</td>
                  <td>OPD</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>M1235</td>
                  <td>Prithvi Raj</td>
                  <td>9127689010</td>
                  <td>OPD</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>M1235</td>
                  <td>Ananya Singh</td>
                  <td>9127689010</td>
                  <td>OPD</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>M1235</td>
                  <td>Ananya Singh</td>
                  <td>9127689010</td>
                  <td>OPD</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>M1235</td>
                  <td>Ananya Singh</td>
                  <td>9127689010</td>
                  <td>OPD</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>M1235</td>
                  <td>Ananya Singh</td>
                  <td>9127689010</td>
                  <td>OPD</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>M1235</td>
                  <td>Ananya Singh</td>
                  <td>9127689010</td>
                  <td>OPD</td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>
      </div>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}

    </div>
  )
}

export default PrintConfiguration